"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./About.module.scss";
import { fetchAboutSectionFile } from "./about.helpers";
interface Props {
  path: string;
  title: string;
}
export default function AboutHTML(props) {
  const $ = _c(17);
  const [html, setHtml] = useState("");
  let t0;
  let t1;
  if ($[0] !== props.path) {
    t0 = () => {
      fetchAboutSectionFile(props.path).then(setHtml);
    };
    t1 = [props.path];
    $[0] = props.path;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let titleLighter = "";
  let titleDarker = props.title;
  if (props.title?.includes(" ")) {
    let t2;
    if ($[3] !== props.title) {
      t2 = props.title.split(" ");
      $[3] = props.title;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let firstWord;
    let rest;
    if ($[5] !== t2) {
      [firstWord, ...rest] = t2;
      $[5] = t2;
      $[6] = firstWord;
      $[7] = rest;
    } else {
      firstWord = $[6];
      rest = $[7];
    }
    titleLighter = firstWord;
    titleDarker = rest.join(" ");
  }
  let t2;
  if ($[8] !== props.title || $[9] !== titleDarker || $[10] !== titleLighter) {
    t2 = props.title && <Row><Col><h1>{titleLighter && `${titleLighter} `}{titleDarker}</h1></Col></Row>;
    $[8] = props.title;
    $[9] = titleDarker;
    $[10] = titleLighter;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== html) {
    t3 = <Row><Col className={styles.htmlContainer} dangerouslySetInnerHTML={{
        __html: html
      }} /></Row>;
    $[12] = html;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t2 || $[15] !== t3) {
    t4 = <Container>{t2}{t3}</Container>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}